import { useFillSwapDerivedState } from '../state/useSwapDerivedState'

export function SwapDerivedStateUpdater() {
  useFillSwapDerivedState()

  return null
}
